<p>payment-promo-text works!</p>
